
import { Component, Vue } from 'vue-property-decorator'
import { CustomButton, Card } from 'ui-library'
import KeyVisualAccount from '@/componentsTenant/images/KeyVisualAccount.vue'

// Tile with component left and image right
@Component({ components: { Card, CustomButton, KeyVisualAccount } })
export default class KeyVisualAccountTile extends Vue {
  private assetsBaseUrl: string = window.ENV_CONFIG.ASSETS_BASE_URL.CUSTOMER_PORTAL || ''
}
